import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { profileSettingsReducerKey } from './ProfileSettingsConstants';
import { init } from './ProfileSettingsActions';
import { isLoading as isLoadingSelector } from './ProfileSettingsSelectors';
import ProfileSettingsReducer from './ProfileSettingsReducer';
import ProfileSettings from './ProfileSettings';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  init: () => dispatch(init()),
});

export default compose(
  withCombinedRouteParams,
  withReducer(profileSettingsReducerKey, ProfileSettingsReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(ProfileSettings);
